const state = {
    mailinglist:[],
}

export default state
